import React from 'react';
export function StrategicQuadrant() {
  return <section className="py-24 bg-[#0d1f35] border-y border-slate-800" data-id="element-189">
      <div className="container mx-auto px-4" data-id="element-190">
        <div className="text-center mb-16" data-id="element-191">
          <h2 className="text-3xl font-bold mb-4" data-id="element-192">
            STRATEGIC QUADRANT ANALYSIS
          </h2>
          <p className="text-slate-400" data-id="element-193">
            BCG Matrix classification of competitive landscape
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative aspect-square md:aspect-[16/9] bg-[#1a2942] rounded-lg border border-slate-700 p-8" data-id="element-194">
          {/* Quadrant Grid */}
          <div className="absolute inset-8 grid grid-cols-2 grid-rows-2 gap-1" data-id="element-195">
            {/* Backgrounds for quadrants */}
            <div className="bg-[#0a1628]/50 p-4 relative border border-slate-700/50 hover:bg-[#0a1628]/80 transition-colors" data-id="element-196">
              <span className="absolute top-4 left-4 text-yellow-500 font-mono text-sm font-bold" data-id="element-197">
                STARS
              </span>
              <span className="absolute top-4 right-4 text-xs text-slate-500" data-id="element-198">
                High Growth, High Share
              </span>

              {/* Competitor Dots */}
              <div className="absolute top-1/3 left-1/2 w-4 h-4 bg-red-500 rounded-full shadow-lg shadow-red-500/50" title="Nexus Corp" data-id="element-199"></div>
            </div>

            <div className="bg-[#0a1628]/50 p-4 relative border border-slate-700/50 hover:bg-[#0a1628]/80 transition-colors" data-id="element-200">
              <span className="absolute top-4 left-4 text-purple-500 font-mono text-sm font-bold" data-id="element-201">
                QUESTION MARKS
              </span>
              <span className="absolute top-4 right-4 text-xs text-slate-500" data-id="element-202">
                High Growth, Low Share
              </span>

              <div className="absolute bottom-1/4 left-1/3 w-3 h-3 bg-orange-500 rounded-full" title="Vortex" data-id="element-203"></div>
              <div className="absolute top-1/2 right-1/4 w-5 h-5 bg-[#00d4ff] rounded-full shadow-[0_0_15px_rgba(0,212,255,0.6)] animate-pulse" title="YOU" data-id="element-204"></div>
            </div>

            <div className="bg-[#0a1628]/50 p-4 relative border border-slate-700/50 hover:bg-[#0a1628]/80 transition-colors" data-id="element-205">
              <span className="absolute top-4 left-4 text-green-500 font-mono text-sm font-bold" data-id="element-206">
                CASH COWS
              </span>
              <span className="absolute top-4 right-4 text-xs text-slate-500" data-id="element-207">
                Low Growth, High Share
              </span>

              <div className="absolute top-1/4 right-1/3 w-3 h-3 bg-yellow-600 rounded-full" title="Omni" data-id="element-208"></div>
            </div>

            <div className="bg-[#0a1628]/50 p-4 relative border border-slate-700/50 hover:bg-[#0a1628]/80 transition-colors" data-id="element-209">
              <span className="absolute top-4 left-4 text-slate-500 font-mono text-sm font-bold" data-id="element-210">
                DOGS
              </span>
              <span className="absolute top-4 right-4 text-xs text-slate-500" data-id="element-211">
                Low Growth, Low Share
              </span>

              <div className="absolute bottom-1/3 right-1/4 w-2 h-2 bg-slate-600 rounded-full" title="Aegis" data-id="element-212"></div>
              <div className="absolute top-1/3 left-1/4 w-2 h-2 bg-slate-600 rounded-full" title="Cyber" data-id="element-213"></div>
            </div>
          </div>

          {/* Center Cross */}
          <div className="absolute inset-8 pointer-events-none flex items-center justify-center" data-id="element-214">
            <div className="w-full h-[2px] bg-slate-700" data-id="element-215"></div>
          </div>
          <div className="absolute inset-8 pointer-events-none flex items-center justify-center" data-id="element-216">
            <div className="h-full w-[2px] bg-slate-700" data-id="element-217"></div>
          </div>
        </div>
      </div>
    </section>;
}